export const eventsCallbacksContent = `# Events & Callbacks

Expose minimal callbacks (either via Provider props or an event bus):

* \`onSignedIn(user)\`
* \`onSignedUp(user)\`
* \`onEntitlementGranted()\`
* \`onPaywallShown()\`
* \`onPaywallDismissed()\`
* \`onCheckoutCompleted()\`

Example:

\`\`\`tsx
<LightswitchProvider
  publishableKey="pk_flow-state-app"
  appSlug="flow-state-app"
  supabaseClient={supabase}
  autoShowPaywall
  onEntitlementGranted={() => console.log("Access granted")}
  onCheckoutCompleted={() => console.log("Checkout done")}
>
  {children}
</LightswitchProvider>
\`\`\``;
